/**
 * Deterministic avatar colours for people/groups without a photo. Same
 * hash → palette mapping the page has always used, so a given name keeps the
 * colour people are used to seeing.
 */

function hashCode(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash + str.charCodeAt(i)) << 0;
  }
  return hash;
}

// [top, bottom] of the gradient.
const PALETTE = [
  ["#71A4DB", "#0071EE"],
  ["#E3A4A4", "#FF7272"],
  ["#E3C4A4", "#FFB872"],
  ["#A2CA75", "#70C808"],
  ["#BF93CC", "#AE4CCC"],
  ["#A5C2E3", "#74B6FF"],
];

/**
 * @param {string} seed - usually the display name
 * @returns {[string, string]} gradient stops
 */
export function avatarGradient(seed) {
  const index = Math.abs((hashCode(seed || "") + 2147483648) % PALETTE.length);
  return PALETTE[index];
}

/**
 * Up to two initials for a display name ("Bryan Nguyen" → "BN").
 * @param {string} name
 * @returns {string}
 */
export function initialsFor(name) {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return "";
  const first = parts[0].charAt(0);
  const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : "";
  return (first + last).toUpperCase();
}
